import { useGlobal } from '@/utils/useGlobal';
import css from './terms.module.scss';

export function Terms() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    return (
        <div className={`terms ${css.terms}`}>
            <p className="title">{t('presale.bundles.terms_title')}</p>
            <p className="content">
                {t.rich('presale.bundles.terms_content', {
                    line: (text: any) => (
                        <Link href={'https://www.affirm.com/terms'} newWin>
                            {text}
                        </Link>
                    ),
                })}
            </p>
        </div>
    );
}
